import { RegistryCompanyResponse } from 'generated/api-client';
import { useCompanyRegistrySearch } from 'modules/company/hooks/useCompanyRegistrySearch';
import React, { CSSProperties, FunctionComponent, useMemo } from 'react';
import { Select } from 'semantic-ui-react';

type Props = {
  siren: string;
  currentSiret: string;
  style?: CSSProperties;
  onSelect: (establishment: RegistryCompanyResponse) => void;
};

export const EstablishmentSelect: FunctionComponent<Props> = ({
  siren,
  currentSiret,
  style,
  onSelect,
}) => {
  const { results, isLoading } = useCompanyRegistrySearch({ siren });

  const options = useMemo(() => {
    const items =
      results?.map((establishment) => ({
        key: establishment.siret,
        value: establishment.siret,
        text: `${establishment.siret} — ${establishment.address.streetAddress} ${establishment.address.postalCode} ${establishment.address.city}`,
      })) ?? [];

    if (items.length === 0 && !isLoading) {
      return [
        {
          key: 'empty',
          value: '',
          text: 'Aucun établissement actif',
          disabled: true,
        },
      ];
    }

    return items;
  }, [results, isLoading]);

  return (
    <Select
      placeholder="Changer l'établissement"
      fluid
      style={style}
      loading={isLoading}
      options={options}
      value={currentSiret}
      onChange={(_, { value }) => {
        const establishment = results?.find((result) => result.siret === value);
        if (establishment) {
          onSelect(establishment);
        }
      }}
    />
  );
};
